import React, { useState } from "react";
import { Card, CardHeader, Collapse, Container, Table } from "reactstrap";
import moment from "moment";
import ReactNumeric from "../../../components/ReactNumeric/ReactNumeric";

export const Facturas = ({ facturas }) => {
    const [open, setOpen] = useState(false);

    const openCollapse = () => {
        setOpen(!open);
    };

    return (
        <div aria-multiselectable={true} className="card-collapse">
            <Card className="card-plain my-0">
                <CardHeader role="tab">
                    <div data-toggle="collapse" className="expanded c-pointer" onClick={openCollapse}>
                        {"Facturas Presentadas"}&nbsp;&nbsp;
                        <i
                            className={
                                !open ? "now-ui-icons arrows-1_minimal-down" : "now-ui-icons arrows-1_minimal-up"
                            }
                        />
                    </div>
                </CardHeader>
                <Collapse isOpen={open}>
                    <Container className="text-center pl-0">
                        <div className={"table-responsive"}>
                            <Table className="adjusttd text-center">
                                <thead className="text-primary">
                                    <tr>
                                        <th>Item</th>
                                        <th className="text-right">No. Factura</th>
                                        <th className="text-center">Fc Emisión</th>
                                        <th>Detalle</th>
                                        <th className="text-right">Valor</th>
                                        <th className="text-right">Valor No Cubierto</th>
                                        <th className={"text-left"}>Observaciones</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {facturas.length === 0 ? (
                                        <React.Fragment>
                                            <tr>
                                                <td colSpan={4}>
                                                    <span>No hay información disponible.</span>
                                                </td>
                                            </tr>
                                        </React.Fragment>
                                    ) : (
                                        <React.Fragment>
                                            {facturas.map((item, index) => (
                                                <tr key={item.cdGastosVam}>
                                                    <td>
                                                        <span>{index + 1}</span>
                                                    </td>
                                                    <td className="text-right">
                                                        <span>{item.numRecibo}</span>
                                                    </td>
                                                    <td className="text-center">
                                                        <span>
                                                            {item.fcGasto
                                                                ? moment(item.fcGasto)
                                                                      .locale("moment/locale/es")
                                                                      .local()
                                                                      .format("DD/MMM/YYYY")
                                                                : null}
                                                        </span>
                                                    </td>
                                                    <td className="text-left">
                                                        <span>{item.detalle}</span>
                                                    </td>
                                                    <td className="text-right">
                                                        <ReactNumeric
                                                            valuex={item.valor ? item.valor : 0}
                                                            readOnly
                                                            className="form-control-plaintext text-right"
                                                        />
                                                    </td>
                                                    <td className="text-right">
                                                        <ReactNumeric
                                                            valuex={item.valNoCubierto || 0}
                                                            readOnly
                                                            className="form-control-plaintext text-right"
                                                        />
                                                    </td>
                                                    <td className="text-left">
                                                        <span>{item.obsGastoVam}</span>
                                                    </td>
                                                </tr>
                                            ))}
                                        </React.Fragment>
                                    )}
                                </tbody>
                            </Table>
                        </div>
                    </Container>
                </Collapse>
            </Card>
        </div>
    );
};
